var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWheelchair(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("rect", {
    stroke: "#000",
    strokeWidth: 2,
    x: 1,
    y: 1,
    width: 28,
    height: 28,
    rx: 6
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#000"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.69 14.444h3.62c.315 0 .57.28.57.624v.16c0 .345-.255.624-.57.624h-3.62c-.315 0-.57-.279-.57-.624v-.16c0-.344.255-.624.57-.624M17.34 23.267C16.188 24.4 14.79 25 13.038 25 9.703 25 7 22.415 7 19.226c0-1.85.81-3.415 2.225-4.472l.258-.187a.76.76 0 0 1 1.055.233l.07.11a.78.78 0 0 1-.221 1.065l-.13.122c-.902.743-1.448 1.788-1.448 3.006 0 2.24 1.926 4.055 4.302 4.055 1.26 0 2.403-.51 3.192-1.324l.237-.19c.328-.262.846-.124 1.1.21l.08.104a.78.78 0 0 1-.13 1.08l-.25.229z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m13.556 11.838.547 5.268h4.824c.557 0 1.023.3 1.143.702.04.068.073.143.101.22l1.434 3.95.976-.262c.625-.168 1.247.128 1.39.66.141.531-.25 1.1-.876 1.269l-1.475.436c-.072.062-.156.072-.247.106-.165.059-.38.141-.546.096-.435-.006-.645-.417-.763-.857l-1.633-4.507-5.323-.001c-.648 0-1.173-.405-1.173-.905 0-.078-.066-.154-.042-.225l-.13-6.036c-.082-1.027 1.833-1.203 1.793.086M11.76 8.111C11.76 6.945 12.673 6 13.8 6c1.126 0 2.04.945 2.04 2.111 0 1.166-.914 2.111-2.04 2.111-1.127 0-2.04-.945-2.04-2.11"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWheelchair);
export default __webpack_public_path__ + "static/media/wheelchair.01def73810c950cf847e73fdfaab67b7.svg";
export { ForwardRef as ReactComponent };